import React from 'react';
import { NumericFormat } from 'react-number-format';
import TextField from '@mui/material/TextField';
import { inputStyle } from './styles';

// Common props for both numeric input components
const commonNumericProps = {
  thousandSeparator: ",",
};

export const IntegerInput = ({ 
  name, 
  value, 
  onChange, 
  placeholder, 
  label, 
  disabled, 
  error, 
  maxValue, 
  sx,
  onBlur,
  InputProps = {},
  allowNegative = false // <-- add this prop, default false
}) => {
  // Convert null or undefined values to empty string for display
  const displayValue = value === null || value === undefined ? '' : value;

  return (
    <NumericFormat
      customInput={TextField}
      {...commonNumericProps}
      name={name}
      value={displayValue}
      placeholder={placeholder}
      label={label}
      variant="filled"
      fullWidth
      decimalScale={0}
      disabled={disabled}
      error={error}
      onBlur={onBlur}
      sx={{ ...inputStyle, ...sx }}
      InputProps={{ 
        disableUnderline: true,
        ...InputProps 
      }}
      // zero values are always allowed; allowNegative controls only negatives
      allowNegative={allowNegative} // <-- use prop here
      isAllowed={(values) => {
        const { floatValue } = values;
        if (floatValue === undefined) return true;
        return maxValue ? floatValue <= maxValue : true;
      }}
      onValueChange={(values, sourceInfo) => {
        if (!onChange) return;
        
        const { value, floatValue } = values;
        // If the input is cleared, explicitly set value to null
        if (value === '' || value === undefined) {
          onChange({ target: { name, value: null } });
          return;
        }
        
        // Otherwise pass the float value
        onChange({ target: { name, value: floatValue } });
      }}
    />
  );
};

export const FloatInput = ({
  name,
  value,
  onChange,
  placeholder,
  label,
  disabled,
  error,
  maxValue,
  sx,
  onBlur,
  InputProps = {},
  decimalScale = 4, // Allow customizable decimal scale
  allowNegative = false
}) => {
  // Convert null or undefined values to empty string for display
  const displayValue = value === null || value === undefined ? '' : value;

  return (
    <NumericFormat
      customInput={TextField}
      {...commonNumericProps}
      name={name}
      value={displayValue}
      placeholder={placeholder}
      label={label}
      variant="filled"
      fullWidth
      decimalScale={decimalScale}
      disabled={disabled}
      error={error}
      onBlur={onBlur}
      sx={{ ...inputStyle, ...sx }}
      InputProps={{
        disableUnderline: true,
        ...InputProps
      }}
      allowNegative={allowNegative}
      isAllowed={(values) => {
        const { floatValue } = values;
        if (floatValue === undefined) return true;
        return maxValue ? floatValue <= maxValue : true;
      }}
      onValueChange={(values, sourceInfo) => {
        if (!onChange) return;
        
        const { value, floatValue } = values;
        // If the input is cleared, explicitly set value to null
        if (value === '' || value === undefined) {
          onChange({ target: { name, value: null } });
          return;
        }
        
        // Otherwise pass the float value
        onChange({ target: { name, value: floatValue } });
      }}
    />
  );
};
